"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilteredColumnTree = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right20"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down20"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _style = _interopRequireDefault(require("./style.css"));
var _index = require("../Condition/index.js");
var _index2 = require("../../index.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var getFilteredColumnTree = exports.getFilteredColumnTree = function getFilteredColumnTree(search, columnTree) {
  var result = (0, _cloneDeep2["default"])(columnTree);
  search = search.toLowerCase();
  function filterTree(node) {
    if (node.children) {
      node.children = node.children.filter(filterTree);
      return node.children.length > 0;
    }
    return node.label.toLowerCase().includes(search);
  }
  return result.filter(filterTree);
};
var Component = function Component(props) {
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    search = _useState2[0],
    setSearch = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    expanded = _useState4[0],
    setExpanded = _useState4[1];
  var columnTree = (0, _react.useContext)(_index2.ColumnTreeContext);
  var filteredTree = (0, _react.useMemo)(function () {
    return getFilteredColumnTree(search, columnTree);
  }, [search, columnTree]);
  var toggleExpanded = function toggleExpanded(value) {
    setExpanded((0, _xor2["default"])(expanded, [value]));
  };
  var _traverse = function traverse(node) {
    if (node.children) {
      var isExpanded = expanded.includes(node.id) || !!search;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].header,
        onClick: function onClick() {
          return toggleExpanded(node.id);
        }
      }, isExpanded ? /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], {
        spaceRight: true
      }) : /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], {
        spaceRight: true
      }), node.label), isExpanded && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].level
      }, node.children.map(function (child) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: child.id
        }, _traverse(child));
      })));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "form-check"
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-check-label"
    }, /*#__PURE__*/_react["default"].createElement("input", {
      className: "form-check-input",
      type: "radio",
      name: "column",
      value: node.id,
      checked: node.id === props.selectedColumn,
      onChange: function onChange(e) {
        props.onSubmit(node);
        props.closeModal();
      },
      disabled: !(node.type in _index.allConditions)
    }), ' ', node.label));
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    name: "search",
    className: "form-control",
    placeholder: "search",
    style: {
      width: '10em'
    },
    autoFocus: true,
    autoComplete: "off",
    value: search,
    onChange: function onChange(e) {
      return setSearch(e.target.value);
    }
  })), filteredTree.length === 0 ? 'No column found' : filteredTree.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: item.id
    }, _traverse(item));
  }));
};
Component.propTypes = {
  selectedColumn: _propTypes["default"].string,
  closeModal: _propTypes["default"].func,
  onSubmit: _propTypes["default"].func
};
Component.defaultProps = {
  selectedColumn: ''
};
var _default = exports["default"] = Component;